<template>
    <div class="p-8 rounded-lg bg-white shadow-lg flex items-center space-x-6 transition-transform duration-200 hover:-translate-y-2">
      <div class="flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 text-blue-500 text-3xl">
        <i :class="`icon-${icon}`"></i>
      </div>
      <div>
        <p class="text-3xl font-bold text-gray-800">{{ value }}</p>
        <p class="text-sm text-gray-500">{{ title }}</p>
      </div>
    </div>
  </template>

  <script>
  export default {
    name: "StatCard",
    props: {
      title: String,
      value: String,
      icon: String,
    },
  };
  </script>

  <style scoped>
  /* Дополнительные стили, если нужно */
  </style>
